/**
 * =====================================================================
 * 작 업 명  : 전역 함수 처리
 * 파 일 명  : $global.js
 * 변경이력 
 * 2022-02-16 / 정태화 / 최초작성
 * 2022-10-17 / 정태화 / 도메인 조회, 업체번호 조회 추가 
 * =====================================================================
 */
import { $axios } from "@/dot-ui/index.js";

const $global = 
{
    // URL 파라미터 조회
    getUrlParams() 
    {
        var params = {};  
        window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, 
            function(str, key, value) { 
                params[key] = value; 
            }
        );     
        return params; 
    },
    // JWS 토큰 파싱
    parseJwtToken(token)
    {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    },
    // 도메인 조회 추가 (2022-10-17 / 정태화)
    getDomain(url)
    {
        let domain = new URL(url);
        let result = domain.hostname;
        if (domain.port && domain.port != "80") {
            result += ":" + domain.port;
        }
        //console.log("domain.host=" + domain.host);
        //console.log("domain.port=" + domain.port);
        return result;
    },
    // 업체번호 조회 추가 (2022-10-17 / 정태화)
    async getCompNo(domain, callback)
    {
        let url = "/site-app/v1/domains/" + domain;
        let response = await $axios.get(url);
        let json = response.data;
        let compNo = json.COMP_NO;
        callback(compNo);
    },
}

export {
    $global
}

